import axios from "axios";
import config from "./config";

//创建axios实例
const instance = axios.create({
    baseURL: config.baseUrl,
    timeout: config.timeout,
});


// 请求拦截器
instance.interceptors.request.use(function (config) {
    if (localStorage.getItem("Token")) config.headers.Token = localStorage.getItem("Token")
    if (config.url == "/api/upload") config.headers["Content-Type"] = "multipart/form-data"
    return config;
}, function (error) {
    return Promise.reject(error);
});


//响应拦截器
instance.interceptors.response.use(function (response) {
    let code = response.data.code
    if (code == -1) {
        alert("token失效,请重新登录")
        config.baseUrl == "http://127.0.0.1:5000" ? location.href = "http://localhost:8080" : location.href = config.baseUrl
        return false
    } else {
        return response.data;
    }
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance